import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "ReportEmail/";

const getReportEmailById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportEmailById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const getReportEmails = async (reportTypeId) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportEmails?reportTypeId=' + reportTypeId, constants.REQUIRE_INTERCEPTORS);

const saveReportEmail = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'SaveReportEmail', model, constants.REQUIRE_INTERCEPTORS);

const deleteReportEmail = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'DeleteReportEmail?id=' + id, constants.REQUIRE_INTERCEPTORS);

export {
    getReportEmailById,
    getReportEmails,
    saveReportEmail,
    deleteReportEmail
}